import { Link } from 'react-router-dom';

import { isSvpAsset } from '../../modules/helpers';
import { getPath, routeNames } from '../../shared/helpers/routes';
import { AssetLink } from '../AssetLink/AssetLink';

import type {
  DetailedHTMLProps,
  HTMLAttributes,
  VFC,
  ReactElement,
} from 'react';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { Vendor } from '../../types';

interface ComponentLinkProps
  extends Omit<
    DetailedHTMLProps<HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>,
    'ref'
  > {
  item: SvpAssetAdditional | SvpCategoryAdditional;
  vendor: Vendor;
  disabled: boolean;
  children: ReactElement;
}

const ComponentLink: VFC<ComponentLinkProps> = ({
  item,
  vendor,
  disabled,
  children,
  ...props
}) => {
  if (disabled) {
    return children;
  }

  if (isSvpAsset(item)) {
    return <AssetLink asset={item}> {children} </AssetLink>;
  }

  const targetUrl = getPath(routeNames.category, {
    vendor,
    category: item,
  });

  return (
    <Link {...props} to={targetUrl}>
      {children}
    </Link>
  );
};

export { ComponentLink };
